export default __webpack_public_path__ + "static/media/Hood of Dark Malice.a8bdb668.jpg";